import React, { useEffect, useState, useMemo } from "react";
import { useOutletContext } from "react-router-dom";
import CourseDetailsPageHeader from "../../CourseDetailsPageHeader/CourseDetailsPageHeader";
import FirstFormContent from "../FirstFormContent/FirstFormContent";
import LoadingSpinner from "../../../../shared/components/LoadingSpinner/LoadingSpinner";

const FirstFormPageDetails = () => {
  const [isLoading, setIsLoading] = useState(true);

  // Get outlet context (it might be undefined on pages that don't provide it)
  const outletContext = useOutletContext() || {};

  // Memoize the setContentLoaded function so its reference remains stable.
  const setContentLoaded = useMemo(
    () => outletContext.setContentLoaded || (() => {}),
    [outletContext.setContentLoaded]
  );

  useEffect(() => {
    // Simulate loading for 500ms (adjust if needed)
    const timer = setTimeout(() => {
      setIsLoading(false);
      // Signal that this page is loaded.
      setContentLoaded(true);
    }, 500);
    return () => clearTimeout(timer);
  }, [setContentLoaded]);

  if (isLoading) {
    return (
      <div style={{ margin: "auto" }}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="courseMaterialsPage">
      <CourseDetailsPageHeader title="SCA First Form Courses Materials" />
      <FirstFormContent />
    </div>
  );
};

export default FirstFormPageDetails;
